import React from "react";
import '../../css/components/shared/VehicleFavouriteIcon.css';

function VehicleFavouriteIcon({ IsFavorite, handleClickFavourite }) {

    const printSVG = () => {
        if (IsFavorite) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="25.511" height="24.452" viewBox="0 0 25.511 24.452">
                <path id="favorite" data-name="Icon awesome-star" d="M12.368.814,9.38,6.872,2.7,7.847a1.465,1.465,0,0,0-.81,2.5l4.836,4.713L5.578,21.715A1.463,1.463,0,0,0,7.7,23.257l5.98-3.143,5.98,3.143a1.464,1.464,0,0,0,2.123-1.542L20.64,15.058l4.836-4.713a1.465,1.465,0,0,0-.81-2.5l-6.685-.975L14.994.814a1.465,1.465,0,0,0-2.626,0Z" transform="translate(-0.925 0.501)" fill="#fff" stroke="black" strokeWidth="0" opacity="0.703" />
            </svg>
        }
        else {
            return <svg xmlns="http://www.w3.org/2000/svg" width="25.511" height="24.452" viewBox="0 0 25.511 24.452">
                <path id="no_favorite" data-name="Icon awesome-star" d="M12.368.814,9.38,6.872,2.7,7.847a1.465,1.465,0,0,0-.81,2.5l4.836,4.713L5.578,21.715A1.463,1.463,0,0,0,7.7,23.257l5.98-3.143,5.98,3.143a1.464,1.464,0,0,0,2.123-1.542L20.64,15.058l4.836-4.713a1.465,1.465,0,0,0-.81-2.5l-6.685-.975L14.994.814a1.465,1.465,0,0,0-2.626,0Z" transform="translate(-0.925 0.501)" fill="#fff" stroke="black" strokeWidth="0" opacity="0.703" />
            </svg>
        }
    }

    return (
        <button className="c-favorite-icon" onClick={() => handleClickFavourite()}>
            <div>{printSVG()}</div>
        </button>
    );
}

export default VehicleFavouriteIcon;
